/**
 * @generated SignedSource<<c911df138434165e1df56a149c5ed87d>>
 * @relayHash 3c5abea4712e217d7b3561b0c6d826bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8

import type { ConcreteRequest } from 'relay-runtime';
export type InvitedAppShortcutsRecommendationsQuery$variables = {
  product: string;
  tenantId?: string | null;
};
export type InvitedAppShortcutsRecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly __typename: "GrowthRecRecommendations";
      readonly context: {
        readonly product: string | null;
        readonly sessionId: string | null;
        readonly tenantId: string | null;
        readonly useCase: string | null;
      } | null;
      readonly data: ReadonlyArray<{
        readonly entityId: string;
        readonly reasons: ReadonlyArray<string> | null;
        readonly score: number | null;
      }> | null;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly identifier: string | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type InvitedAppShortcutsRecommendationsQuery = {
  response: InvitedAppShortcutsRecommendationsQuery$data;
  variables: InvitedAppShortcutsRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "invitedAppShortcuts"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v5 = {
  "kind": "ScalarField",
  "name": "reasons"
},
v6 = {
  "kind": "ScalarField",
  "name": "score"
},
v7 = {
  "concreteType": "GrowthRecContextResult",
  "kind": "LinkedField",
  "name": "context",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "tenantId"
    },
    {
      "kind": "ScalarField",
      "name": "product"
    },
    {
      "kind": "ScalarField",
      "name": "useCase"
    },
    {
      "kind": "ScalarField",
      "name": "sessionId"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v9 = {
  "kind": "ScalarField",
  "name": "message"
},
v10 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v11 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3c5abea4712e217d7b3561b0c6d826bb",
    "id": "15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8",
    "metadata": {},
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "operationKind": "query",
    "text": "query InvitedAppShortcutsRecommendationsQuery($tenantId:ID,$product:String!){growthRecommendations{recommendations(context:{tenantId:$tenantId,product:$product,useCase:\"invitedAppShortcuts\"}){__typename,...on GrowthRecRecommendations{data{__typename,entityId,reasons,score},context{tenantId,product,useCase,sessionId}},...on QueryError{identifier,message,extensions{__typename,statusCode,errorType}}}}}"
  }
};
})();

(node as any).hash = "186413c3c978a3bb94c6bc4b5f252e32";

export default node;
